var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDingdongTopDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.89 28.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{stroke:#8e9fd0;}.cls-3{stroke-width:2px;}.cls-5{fill:#8e9fd0;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-2.55 -0.67)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.45,
    cy: 12.45,
    r: 11.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 6.1,
    cy: 16.55,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.33,
    cy: 11.67,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 13.97,
    cy: 19.77,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 19.26,
    cy: 18.24,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 13.17,
    cy: 5.52,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 9.62,
    cy: 9.5,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.06,
    cy: 13.39,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 17.74,
    cy: 9.17,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12.86,
    cy: 12.76,
    r: 2.42
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.22,
    y: 25.75,
    width: 22.84,
    height: 2.54,
    rx: 1.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.89,
    y: 11.68,
    width: 2.1,
    height: 16.92,
    transform: "matrix(0.84, 0.54, -0.54, 0.84, 10.11, -3.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 18.4,
    y: 11.68,
    width: 2.1,
    height: 16.92,
    transform: "translate(44.17 25.86) rotate(147.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDingdongTopDark);
export default __webpack_public_path__ + "static/media/dingdongTopDark.e84bfcbc5c7424bf894a451958640877.svg";
export { ForwardRef as ReactComponent };